/**
 * @generated SignedSource<<b817b117a8785cafd7776154f5047087>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type NavigationTeamButton_project$data = {
  readonly id: string;
  readonly teamsConnected?: {
    readonly totalCount: number | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "NavigationTeamButton_project";
};
export type NavigationTeamButton_project$key = {
  readonly " $data"?: NavigationTeamButton_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavigationTeamButton_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "NavigationTeamButton_project",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "GraphStoreSimplifiedTeamConnectedToContainerInverseConnection",
          "kind": "LinkedField",
          "name": "teamsConnected",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "totalCount"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "3b9f9c19a3b51f50bca5f46f2c43543d";

export default node;
